import Vue from "vue";
import VueRouter from "vue-router";
import VueCarousel from "vue-carousel";
//Colaboradores
import Colaboradores from "../views/Colaboradores/Colaboradores.vue";

// paciente
import BandejaPacientes from "../views/BandejaPacientes.vue";
import Paciente from "../views/Paciente.vue";
import PacienteCu from "../views/PacienteCU.vue";
import HistoriaClinicaEdicionPorIdPacienteClinica
    from '../views/perfilPacientes/historialClinica/HistoriaClinicaEdicionPorIdPacienteClinica.vue';
import HistoriaNinoLink from '../views/perfilPacientes/historialClinica/HistoriaNinoLink.vue';
//import CambioOgCabecera from "../views/perfilPacientes/CambioOgCabecera.vue";
import CambioEspecialista from "../views/perfilPacientes/CambioEspecialista.vue";
import CambioEspecialistaMasivo from "../views/perfilPacientes/CambioEspecialistaTratamientos.vue";

import DisponibilidadCitas from "../views/DisponibilidadCita/DisponibilidadCita.vue";
import DisponibilidadCitaGrafico from "../views/DisponibilidadCita/DisponibilidadCitaGrafico.vue";

import DashboardCdxe from "../views/IndicadoresCdxe/DashboardCdxe.vue";

import Dashboard from "../views/Dashboard.vue";
import Tratamientos from "../views/Tratamientos.vue";
import Tratamiento from "../views/Tratamiento.vue";
import TratamientoAdicionales from "../views/TratamientoAdicionales.vue";

import Treatment from "../views/Treatment.vue";

import TratamientosHojaDiagnostico from "../views/TratamientosHojaDiagnostico.vue";
import BandejaRequisicion from "../views/Requisiciones/BandejaRequisicion.vue";
import AltaPrecioRequisicion from "../views/Requisiciones/AltaPrecios.vue"

import AdministracionSesion from "../views/Operations/AdministracionSesion.vue";

import movimientosSaldo from "../views/SaldosTraspasos/movimientosSaldo.vue";
import admAutorizaciones from "../views/SaldosTraspasos/admAutorizaciones.vue";
import admCoordinadores from "../views/SaldosTraspasos/admCoordinadores.vue";
import bandejaSolicitudesSaldo from "../views/SaldosTraspasos/bandejaSolicitudesSaldo.vue";
import bandejaAutorizaciones from "../views/SaldosTraspasos/bandejaAutorizaciones.vue";
import bandejaContabilidadSaldo from "../views/SaldosTraspasos/bandejaContabilidadSaldo.vue";

import Adminclinicas from "../views/Operations/Adminclinicas.vue";

// Herramientas
import terminosCondiciones from "@/views/administracionRenovacionPortal/terminosCondiciones";

Vue.use(VueCarousel);

// CDx

import UnificacionPacientes_View from "../views/UnificacionPacientes_View.vue";

import Schedule from "../views/Schedule.vue";

// planes

import BandejaHallazgo from "../views/CDX/BandejaHallazgo.vue";
import BandejaHallazgoRechazados from "../views/CDX/BandejaHallazgoRechazados.vue";

import BandejaCoordinadorEspecialidadReplicaRechazada
    from "../views/BandejaCoordinadorEspecialidadReplicaRechazada.vue";

import CambioMSI from "../views/Pagos/CambioMSI.vue";


import Coloniacp from "../views/ColoniaCp.vue";


import Login from "../views/Login.vue";
import BandejaClinicaHallazgo from "../views/BandejaClinicaHallazgo.vue";
import BandejaEmbajadorHallazgoRechazadosPendientes from "../views/BandejaEmbajadorHallazgoRechazadosPendientes.vue";

//Configuracion clinica
import agendaDoctores from "../views/agendaDoctores.vue";
import AgendaClinica from "../views/agendaClinica/agendaClinica.vue";
import horarioSillon from "@/views/horarioSillon/horarioSillon.vue";
import HorarioClinica from "../views/horarioClinica/HorarioClinica.vue";

import PlanesIndex from "../views/planes/planesIndex";
import PlanConvenio from "../views/planconvenionuevo";

//Empresas
import admin from '../views/Empresas/Alta/admin-empresas';
import busqueda from '../views/Empresas/Empresas/busqueda';
import EmpresaGrupo from '../views/Empresas/Empresas/EmpresaGrupo';
import EmpresaTipo from '../views/Empresas/Empresas/EmpresaTipo';
import tratamientoSesion from '../views/TratamientosSesion/tratamientoSesion';
import AdminCuentas from '../views/Empresas/Cuenta/admin-cuentas.vue';

// AVPT
import avptIndex from "../views/avpt/avptIndex";

//Soluciones

//menus
import menuIndex from "../views/catalogos/munuIndex";
import usuarios from "../views/usuarios/usuarios";
import permisosIndex from "../views/catalogos/permisosIndex";
import gruposPerfilesIndex from "../views/catalogos/gruposPerfilesIndex";

//Perfiles
import PerfilesIndex from "../views/catalogos/PerfilesIndex";


import corteCaja from "../views/corteCaja/corteCaja";


//import PTIAltoRiesgoBandejaCalidadDental from "../views/PTIAltoRiesgo/BandejaCalidadDental.vue";
//import PTIAltoRiesgoBandejaCoordinadorEspecialidad from "../views/PTIAltoRiesgo/BandejaCoordinadorEspecialidad.vue";

/*  Reportes  */


Vue.use(VueRouter);

import LocalStorageService from "../services/LocalStorageService";
import Home from "../views/Home";


import BandejaEspecialista from "../views/BandejaEspecialista.vue";
import areasIndex from "../views/catalogos/areasIndex";

//cuentas bancarias
import AdministracionCuentas from "../views/cuentasBancarias/Administracion.vue";

import postales from "../views/Postales.vue";
import postal from "../views/Postal.vue";
import Compensaciones from "../views/Compensaciones/Compensaciones.vue"

import BandejaDoctorHallazgo from "../views/BandejaDoctorHallazgo.vue";

import ReporteIngresos from "../views/Reportes/ingresos/ReporteIngresos";
import ReporteTxPxa from "../views/Reportes/ingresos/ReporteTxPxa";
import ReporteArpu from "../views/Reportes/ingresos/ReporteArpu";

import ReporteIngresoDetalle from "../views/Reportes/ingresos/ReporteIngresoDetalle";


import AsignarEditarPlanConvenioPaciente from "@/views/planes/asignarEditarPlanConvenioPaciente.vue";
import Modulos from "../views/ventas/modulos/Modulos";

import Reporte from "../views/Reporte.vue";
import altaPlanesMasivo from "@/views/planes/altaPlanesMasivo";
import AltaPacientesBbva from "@/views/planes/AltaPacientesBbva";


import configuracionPuesto from "../views/catalogos/configuracionPuesto.vue";
import especialidades from "../views/catalogos/especialidades";
import reporteCorte from "@/views/Reportes/reporteCorte";

//VistasComponentes de Convenios Adrian
import ConvenioMembresias from "@/views/Convenios/EstructuraMembresiasPolizas/Membresias.vue";

//reportes
import reporteTratamientosRealizados from "@/views/Reportes/reporteTratamientosRealizados";
import reporteSalubridad from "@/views/Reportes/reporteSalubridad";
import reportesPreciosTratamientos from "@/views/Reportes/reportesPreciosTratamientos";
import reportesEscenariosPTIS from "@/views/Reportes/PTIS/reportesEscenariosPTIS";
import reporteIngresosDoctor from "@/views/Reportes/reporteIngresosDoctor";
import reporteCitas from "@/views/Reportes/reporteCitas";
import ReporteRequisiciones from "../views/Reportes/reporteRequisiciones.vue";
import ReporteIngresoConProyeccionYObjetivos from "@/views/Reportes/ingresos/ReporteIngresoConProyeccionYObjetivos.vue";
import AdministracionFacturas from "@/components/reportes/AdministracionFacturas";
import BajaPorArchivo from "@/views/planes/BajaPorArchivo";
import DescuentoTratamiento from "@/views/planes/DescuentoTratamiento";
import canje from "@/views/planes/canje";
import FacturasCorteCaja from "../views/corteCaja/FacturasCorteCaja";
import ComisionesDos from "../views/Compensaciones/Comisiones";
import NotaCredito from "@/views/corteCaja/NotaCredito";
import ReporteConsultaDiaria from "@/views/Reportes/ingresos/ReporteConsultaDiaria";
import BandejaCobro from "../views/BandejaCobro.vue";
import ReporteGestionVentas from "@/views/Reportes/ingresos/ReporteGestionVentas";
import ReporteAtenciones from "@/views/Reportes/ingresos/ReporteAtenciones";


// Saldos, transferencias y cashback
import Movimientos from "@/views/movimientos/Movimientos";
import CrearMovimiento from "@/views/movimientos/CrearMovimiento";
import PreciosTratamientos from "@/views/PreciosTratamientos/PreciosTratamientos";
import cajaSesion from "../views/cajaSesion/cajaSesionV2";

//ETL
import ETLPrincipal from "@/views/etl/Etl";
import ETLCaracteres from "@/views/etl/Caracteres";
import HistorialEmergenciaLink from "@/views/perfilPacientes/historialClinica/HistorialEmergenciaLink";
import PtiPresuntivoSinSDI from "@/views/PtiPresuntivoSinSDI";

import AgentesPromotores from "@/views/etl/AgentesPromotores";

import SolicitudBaja from "@/views/Colaboradores/SolicitudesBajaColaboradores";
import promociones from "../views/promociones/promociones";
import formularioPromociones from "../views/promociones/formularioPromociones";



//tickets


import motivoRechazoPti from "../views/catalogos/motivoRechazoPti";
import MotivoRechazoEE from "../views/catalogos/MotivoRechazoEE";
import reporteReembolsos from "@/views/Reportes/reporteReembolsos";
import cargaHdxEce from "../views/catalogos/cargaHdxEce";
import configuracionHdxCompletas from "../views/catalogos/configuracionHdxCompletas";
import reporteAsignacionPolizas from "../views/Reportes/reporteAsignacionPolizas";
import BandejaEmbajadorSeguimiento from "@/views/BandejaEmbajadorSeguimiento";

import tipoSolicitud from "@/views/catalogos/tipoSolicitud";
import FacturaLinea from "../views/FacturaLinea";
import adminPortalComercial from "../views/catalogos/adminPortalComercial";
import adminRenovacionPortalComercial from "@/views/administracionRenovacionPortal/adminRenovacionPortalComercial";
import SLASeguimientoPTI from "@/views/catalogos/SLASeguimientoPTI";
import facturacionLineaPortal from "@/views/administracionRenovacionPortal/facturacionLineaPortal"
import BandejaInterConsultaFull from "@/components/Interconsulta/BandejaInterConsultaFull";
import TabsFinanciamiento from "@/views/catalogos/Financiamiento/TabsFinanciamiento";
import reporteUsabilidad from "@/views/Reportes/reporteUsabilidad";
import documentacionLegal from "@/components/portalAutoServicioAdministracion/documentacionLegal";
import tipoDocumentoLegal from "../views/catalogos/tipoDocumentoLegal";

import GarantiasIndex from "../views/Garantias/GaratiasRAS/GarantiasIndex";

import BandejaQuejas from "../views/Garantias/GaratiasRAS/BandejaQuejas";
import ConfiguracionAvpt from "../views/avpt/ConfiguracionAvpt";
import QREce from "../views/QRECE";
import Garantias from "@/views/Garantias/Garantias";


import ConfiguracionEstatus from "../components/bandejaAvpt/ConfiguracionEstatus";
import BandejaSeguimiento from "../components/bandejaAvpt/BandejaSeguimiento";
import QuejasClinica from "../views/Garantias/GaratiasRAS/QuejasClinica";
import BandejaSeguimientoAnfitrion from "../components/bandejaAvpt/BandejaSeguimientoAnfitrion";

import MedicionIndicadorAvpt from "../components/bandejaAvpt/MedicionIndicadorAvpt";
import NuevaBandejaEE from "../views/PTI/NuevaBandejaEE";
import PadecimientosVista from "../views/catalogos/padecimientosVista";
import ComisionesEspecialista from "../components/comisionesEspecialista/ConfiguracionComisionesEspecialista.vue"
import ListaEspera from "../views/modalsAgendaInteligente/ListaEspera";
import EstatusListadeEspera from "../views/modalsAgendaInteligente/EstatusListadeEspera";
import BandaMultiplicador from "../views/bandaMultiplicador/BandaMultiplicadora";
import CFDI from "../views/catalogos/CFDI.vue"
import configuracionAgenda from "../views/configuracionAgenda";

//Haz
import PagoMSI from "@/views/PagoMSI/PagoMSI";

import reporteEscenarioPTISV2 from "@/views/Reportes/PTIS_NM2/reporteEscenarioPTISV2";
import RegimenFiscal from "@/views/catalogos/RegimenFiscal";
import ConfiguracionPerfil from "@/views/configuracionPerfil";
import ReporteUsuarios from "@/views/Reportes/ReporteUsuarios";
import BandejaDescentralizacionRechazados
    from "@/views/bandejaSolicitudesDescentralizados/BandejaDescentralizacionRechazados";

import AdministracionRespuesta from "../components/portalAutoServicioAdministracion/administracionRespuesta";
import ValidacionPTI from "@/components/hojasDiagnostico/ValidacionPTI";
import ScheduleNuevo from "@/views/ScheduleNuevo";
import respuestaRecordatorioCorreoPago from "@/views/administracionRenovacionPortal/respuestaRecordatorioCorreoPago"
import ConfiguracionFormularioHc from "@/views/ConfiguracionFormularioHc";
import PreguntasHc from "@/components/PreguntasHc";
import BandejaBorradores from "@/components/hojasDiagnostico/BandejaBorradores.vue";
import extension from "@/views/extension.vue";
import EstatusCategoria from "@/views/EstatusCategoria.vue";
import flujoExpedienteDigital from "@/views/flujoExpedienteDigital.vue";
import cupones from "@/views/cupones/cupones.vue";

import vales from "@/views/vales/vales.vue";
import categoriaNuevo from "@/views/catalogos/Categoria.vue";
import FacturacionLineaPortalV2 from "@/views/administracionRenovacionPortal/FacturacionLineaPortalV2.vue";
import PlanningPti from "@/views/PtiDailyPlanning.vue";
import TratamientosPlanesInactivos from "../components/tratamientos_combos/TratamientosPlanesInactivos";
import caracteristicasCategoria from "@/views/catalogos/caracteristicasCategoria.vue";

import CatalogoTratamientos from "@/views/catalogos/CatalogoTratamientos"
import CrearEditarColaborador from "../components/Colaboradores/CrearEditarColaborador.vue"
import Valor from "@/views/catalogos/Valor"
import Extension from "@/views/catalogos/Extension";
import NuevoEsquemaComisiones from "@/views/NuevoEsquemaComisiones.vue"
import resumenInversion from "@/version5/negociacion/resumenInversion";

/*import Argumentario from "@/version5/Argumentario";*/
import CategoriaArgumentario from "@/version5/catalogos/CategoriaArgumentario.vue";
import HojaDiagnostico from "@/version5/diagnostico/HojaDiagnostico.vue";
import BandejaInvisaling from "@/components/invisiling/BandejaInvisaling";
import BandejaEmbajadorHallazgoV5 from "@/version5/bandejas/BandejaEmbajadorHallazgoV5.vue";
import MetodosPagov5 from "@/version5/negociacion/MetodosPagov5";
import DistribucionPagoPTIv5 from "@/version5/negociacion/DistribucionPagoPTIv5";
import ImpresionPtiv5 from "@/version5/negociacion/ImpresionPtiv5";
import SolicitudEdicion from "@/version5/EdicionPti/SolicitudEdicion";


import Preparacion from "../views/LaboratorioEtapa/Preparacion";
import Recoleccion from "../views/laboratorio/Recoleccion";
import Arribo from "../views/LaboratorioEtapa/Arribo";
import IngresoCalidad from "../views/LaboratorioEtapa/IngresoCalidad";
import Produccion from "../views/LaboratorioEtapa/Produccion";
import IngresoClinica from "../views/laboratorio/IngresoClinica";

import ProveedoresERP from "@/views/catalogos/proveedoresERP";
import KitConfiguracion from "@/version5/kitsTratam/KitConfiguracion";
import PacienteOrtopantomografo from "@/version5/catalogos/PacienteOrtopantomografo.vue";
import CategoriaPromociones from "../views/catalogos/categorias-promos/categoriaPromociones";
import estatusPromocion from "../views/catalogos/estatus-promos/estatusPromocion";
import PromocionesV2 from "../views/promocionesV2/promocionesV2";
import ListaPromociones from "../views/promocionesV2/ListaPromociones";
import IntentosSLA from "@/views/Garantias/GaratiasRAS/IntentosSLA";
import dicatamenOperativo from "@/views/Garantias/GaratiasRAS/dicatamenOperativo";
import RevisionSolicitudQueja from "@/views/Garantias/GaratiasRAS/RevisionSolicitudQueja";
import DentalDictamen from "@/views/Garantias/GarantiasComplemento/DentalDictamen";
import dicatamenOperativoVo from "@/views/Garantias/GaratiasRAS/dicatamenOperativoVo";
import CerrarCaso from "@/views/Garantias/GaratiasRAS/CerrarCaso";
import dicatamenOperativoCz from "@/views/Garantias/GaratiasRAS/dicatamenOperativoCz";
import RevisionDictamenes from "@/views/Garantias/GaratiasRAS/RevisionDictamenes";
import FormularioComplementarioQueja from "@/views/Garantias/GaratiasRAS/FormularioComplementarioQueja";
import IntentosSLA2 from "@/views/Garantias/GaratiasRAS/IntentosSLA2";
import AceptacionSolicitud from "@/views/Garantias/GaratiasRAS/AceptacionSolicitud";
/*-----------FIN laboratorio*/
import PlazoFijo from "../views/catalogos/plazoFijo.vue";
import FacturacionExpiroLink from "@/views/administracionRenovacionPortal/FacturacionExpiroLink";

import CatalogoEscaner from "@/views/catalogos/Laboratorio/CatalogoEscaner.vue";
import Laboratorios from "@/views/catalogos/Laboratorio/Laboratorios/Laboratorios.vue";
import Colorimetros from "@/views/catalogos/Laboratorio/Colorimetros/Colorimetros.vue";
import OrdenTrabajoPaciente from "@/views/LaboratorioV2/SolicitudODT/OrdenTrabajoPaciente.vue";
import BandejaGeneralOdts from "@/views/LaboratorioV2/SolicitudODT/BandejaOdts.vue";
import DetalleOdtPaciente from "@/views/LaboratorioV2/OrdenTrabajoPaciente/DetalleOdtPaciente.vue";
import ArgumentarioV2 from "@/views/argumentario/ArgumentarioV2.vue";
import GestionBannerPTI from "@/views/PTI/GestionBannerPTI.vue";

function guard(permiso, next) {
    try {
        if (!LocalStorageService.getService().can(permiso)) {
            if (LocalStorageService.getService().can('RE_01_verDashboard')) {
                next({
                    name: "dashboard"
                });
            } else {
                next({
                    name: "home"
                });
            }
        } else {
            next();
        }
    } catch (e) {
        console.info(e);
        next({
            name: "login"
        });
    }
}

const routes = [


    {
        path: "/",
        name: "login",
        component: Login,
    },
    {
        path: "/home",
        name: "home",
        component: Home,
    },
    {
        path: '*',
        redirect: '/home',
        query: null,
        props: false,
    },



    {
        path: "/postales",
        name: "postales",
        component: postales,
        beforeEnter: (to, from, next) => {
            guard('PO_01_postales', next);
        }
    },
    {
        path: "/postal/:id",
        name: "postal",
        component: postal,
        beforeEnter: (to, from, next) => {
            guard('PO_01_postales', next);
        }
    },

    {
        path: "/configuracionAgenda",
        name: "configuracionAgenda",
        component: configuracionAgenda,
    },

    {
      path: "/ConfiguracionPerfil",
      name: "ConfiguracionPerfil",
      component: ConfiguracionPerfil,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        beforeEnter: (to, from, next) => {
            guard('RE_01_menu', next);
        }
    },
    {
        path: "/pacientes",
        name: "pacientes",
        component: BandejaPacientes,
        beforeEnter: (to, from, next) => {
            guard('CA_01_menu', next);
        }
    },
    {
        path: "/ReporteUsuarios",
        name: "ReporteUsuarios",
        component: ReporteUsuarios,
        beforeEnter: (to, from, next) => {
            guard('Rep_lis_usuario_sistema', next);
        }
    },
    {
        path: "/paciente/:id",
        name: "paciente",
        component: Paciente,
        beforeEnter: (to, from, next) => {
            guard('CA_03_menu', next);
        }
    },
    {
        path: "/paciente/:id/:sesion",
        name: "pacienteses",
        component: Paciente,
        beforeEnter: (to, from, next) => {
            guard('CA_03_menu', next);
        }
    },

    {
        path: "/historia/emergencia/:idPaciente/:idClinica",
        name: "HistoriaEmergenciaLink",
        component: HistorialEmergenciaLink,
    },
    {
        path: "/historiaClinica/:idPaciente(.*)*",
        name: "HistoriaClinicaEdicionPorIdPacienteClinica",
        component: HistoriaClinicaEdicionPorIdPacienteClinica,
    },
    {
        path: "/historia/nino/:idPaciente(.*)*",
        name: "HistoriaNinoLink",
        component: HistoriaNinoLink,
    },
    {
        path: "/pacientes/cu",
        name: "PacienteCu",
        component: PacienteCu,
        beforeEnter: (to, from, next) => {
            guard('Atajo_Nuevo_Px', next);
        }
    },
    {
        path: "/Tratamientos",
        name: "tratamientos",
        component: Tratamientos,
        beforeEnter: (to, from, next) => {
            guard('Cat_Tx', next);
        }
    },
    {
        path: "/Tratamiento/:id",
        name: "tratamiento",
        component: Tratamiento,
        beforeEnter: (to, from, next) => {
            guard('Cat_Tx', next);
        }
    },
    {
        path: "/Tratamientos/adicionales",
        name: "TratamientoAdicionales",
        component: TratamientoAdicionales,
        beforeEnter: (to, from, next) => {
            guard('CA_11_menu', next);
        }
    },

    {
        path: "/Centrodediagnostico/PTIPresuntivo/:id/:idSolicitudEtapa/:idSolicitud/:idEtapa",
        name: "treatment",
        component: Treatment,
        beforeEnter: (to, from, next) => {
            guard('DX_04_ir_pti_presun', next);
        }
    },

    {
        path: "/PTIPresuntivoSinSDI/:id",
        name: "PtiPresuntivoSinSDI",
        component: PtiPresuntivoSinSDI,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_bandeja_og', next);
        }
    },
    {
        path: "/tratamientos/diagnostico/:id",
        name: "tratamientosDiagnostico",
        component: TratamientosHojaDiagnostico,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_bandeja_og', next);
        }
    },

    {
        path: "/unificacion/pacientes",
        name: "UnificacionPacientes_View",
        component: UnificacionPacientes_View,
        beforeEnter: (to, from, next) => {
            guard('Upx_unificacion', next);
        }
    },

    {
        path: "/Schedule",
        name: "Schedule",
        component: Schedule,
        beforeEnter: (to, from, next) => {
            guard('CA_06_menu', next);
        }
    },

    {
        path: "/bandejaHallazgo",
        name: "bandejaHallazgo",
        component: BandejaHallazgo,
        beforeEnter: (to, from, next) => {
            guard('DX_04_menu', next);
        }
    },


    {
        path: "/postal",
        name: "Coloniacp",
        component: Coloniacp,
        beforeEnter: (to, from, next) => {
            guard('BO_20_menu', next);
        }
    },


    {
        path: "/administracion/coordinadores",
        name: "admCoordinadores",
        component: admCoordinadores,
        beforeEnter: (to, from, next) => {
            guard('AC_01_adm_coordinadores', next);
        }
    },
    {
        path: "/administracion/autorizaciones",
        name: "admAutorizaciones",
        component: admAutorizaciones,
        beforeEnter: (to, from, next) => {
            guard('AU_01_Autorizaciones', next);
        }
    },
    {
        path: "/movimientos/saldo",
        name: "movimientosSaldo",
        component: movimientosSaldo,
        beforeEnter: (to, from, next) => {
            guard('BO_22_menu', next);
        }
    },
    {
        path: "/movimientos/solicitudes",
        name: "bandejaSolicitudesSaldo",
        component: bandejaSolicitudesSaldo,
        beforeEnter: (to, from, next) => {
            guard('BO_23_menu', next);
        }
    },
    {
        path: "/movimientos/autorizaciones",
        name: "bandejaAutorizaciones",
        component: bandejaAutorizaciones,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_autozaciones_saldo', next);
        }
    },
    {
        path: "/movimientos/bandeja",
        name: "bandejaContabilidadSaldo",
        component: bandejaContabilidadSaldo,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_autorizar_movimiento', next);
        }
    },
    {
        path: "/Adminclinicas",
        name: "Adminclinicas",
        component: Adminclinicas,
        beforeEnter: (to, from, next) => {
            guard('BO_28_menu', next);
        }
    },

    /*{
        path: "/cabecera/og",
        name: "CambioOgCabecera",
        component: CambioOgCabecera,
        beforeEnter: (to, from, next) => {
            guard('BO_30_menu', next);
        }
    },*/
    {
        path: "/cabecera/especialista",
        name: "CambioEspecialista",
        component: CambioEspecialista,
        beforeEnter: (to, from, next) => {
            guard('BO_31_especialista_tx', next);
        }
    },
    {
        path: "/especialista/masivo",
        name: "CambioEspecialistaMasivo",
        component: CambioEspecialistaMasivo,
        beforeEnter: (to, from, next) => {
            guard('BO_31_especialista_masivo', next);
        }
    },


    {
        path: "/msi",
        name: "CambioMSI",
        component: CambioMSI,
        beforeEnter: (to, from, next) => {
            guard('AD_01_ajuste_dx', next);
        }
    },

    {
        path: "/nuevaBandejaPtis",
        name: "NuevaBandejaEE",
        component: NuevaBandejaEE,
        beforeEnter: (to, from, next) => {
            guard('PR_08_bj_hallazgoEE', next);
        }
    },
    {
        path: "/disponibilidadcita",
        name: "disponibilidadcita",
        component: DisponibilidadCitas,
        beforeEnter: (to, from, next) => {
            guard('DC_01_disp_cita', next);
        }
    },
    {
        path: "/disponibilidadcitagrafico",
        name: "disponibilidadcitagrafico",
        component: DisponibilidadCitaGrafico,
        beforeEnter: (to, from, next) => {
            guard('DC_01_disp_cita_graf', next);
        }
    },
    {
        path: "/cdxe/dashboard",
        name: "dashboardcdxe",
        component: DashboardCdxe,
        beforeEnter: (to, from, next) => {
            guard('DX_11_menu', next);
        }
    },
    {
        path: "/colaboradores",
        name: "colaboradores",
        component: Colaboradores,
        beforeEnter: (to, from, next) => {
            guard('BO_15_menu', next);
        }
    },

    /** configuracion de clinicas */
    {
        path: "/horarioClinica",
        name: "horarioClinica",
        component: HorarioClinica,
        beforeEnter: (to, from, next) => {
            guard('BO_36_horario_clinica', next);
        }
    },
    {
        path: "/agendaClinica",
        name: "agendaClinica",
        component: AgendaClinica,
        beforeEnter: (to, from, next) => {
            guard('BO_05_menu', next);
        }
    },
    {
        path: "/horarioSillon",
        name: "horarioSillon",
        component: horarioSillon,
        beforeEnter: (to, from, next) => {
            guard('BO_05_menu', next);
        }
    },
    {
        path: "/agendaDoctores",
        name: "agendaDoctores",
        component: agendaDoctores,
        beforeEnter: (to, from, next) => {
            guard('BO_17_menu', next);
        }
    },
    /** */
    {
        path: "/empresas/admin",
        name: "admin",
        component: admin,
        beforeEnter: (to, from, next) => {
            guard('BO_11_menu', next);
        }
    },
    {
        path: "/empresas/busqueda",
        name: "busqueda",
        component: busqueda,
        beforeEnter: (to, from, next) => {
            guard('BO_13_Detalle_cuentas', next);
        }
    },
    {
        path: "/empresas/empresaGrupo",
        name: "EmpresaGrupo",
        component: EmpresaGrupo,
        beforeEnter: (to, from, next) => {
            guard('Grupo_empresa', next);
        }
    },
    {
        path: "/empresas/empresaTipo",
        name: "EmpresaTipo",
        component: EmpresaTipo,
        beforeEnter: (to, from, next) => {
            guard('Empresa_tipo', next);
        }
    },
    {
        path: "/requisicion",
        name: "BandejaRequisicion",
        component: BandejaRequisicion,
        beforeEnter: (to, from, next) => {
            guard('RQ_01_Requisiciones', next);
        }
    },

    {
        path: "/requisicion/precios",
        name: "AltaPrecioRequisicion",
        component: AltaPrecioRequisicion,
        beforeEnter: (to, from, next) => {
            guard('RQ_03_Alta_precios', next);
        }
    },
    {
        path: "/planes",
        name: "planes",
        component: PlanesIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_13_menu', next);
        }
    },
    {
        path: "/plan/alta",
        name: "PlanConvenio",
        component: PlanConvenio,
        beforeEnter: (to, from, next) => {
            guard('BO_14_alta_plan', next);
        }
    },
    {
        path: "/plan/modificar/:id",
        name: "PlanConvenioModificar",
        component: PlanConvenio,
        beforeEnter: (to, from, next) => {
            guard('BO_13_mod_plan_conv', next);
        }
    },

    {
        path: "/tratamiento_sesion/:idSesion/:idPaciente/:idDoctor/:nombre",
        name: "tratamientoSesion",
        component: tratamientoSesion,
        beforeEnter: (to, from, next) => {
            guard('RE_05_menu', next);
        }
    },
    /*{
        path: "/ptialtoriesgo/bandejaCalidadDental",
        name: "BandejaCalidadDental",
        component: PTIAltoRiesgoBandejaCalidadDental,
        beforeEnter: (to, from, next) => {
            guard('DX_14_menu', next);
        }
    },
    {
        path: "/ptialtoriesgo/bandejaCoordinadorEspecialidad",
        name: "BandejaCoordinadorEspecialidad",
        component: PTIAltoRiesgoBandejaCoordinadorEspecialidad,
        beforeEnter: (to, from, next) => {
            guard('DX_13_menu', next);
        }
    },*/

    {
        path: "/avpt",
        name: "avpt",
        component: avptIndex,
        beforeEnter: (to, from, next) => {
            guard('avpt', next);
        }
    },

    {
        path: "/catalogo/menu",
        name: "menus",
        component: menuIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_01_menu', next);
        }
    },
    {
        path: "/catalogo/perfiles",
        name: "perfiles",
        component: PerfilesIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_06_menu', next);
        }
    },
    {
        path: "/catalogo/permisos",
        name: "permisos",
        component: permisosIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_02_menu', next);
        }
    },
    {
        path: "/catalogo/usuarios",
        name: "usuarios",
        component: usuarios,
        beforeEnter: (to, from, next) => {
            guard('BO_04_menu', next);
        }
    },
    {
        path: "/catalogo/gruposPerfiles",
        name: "gruposPerfiles",
        component: gruposPerfilesIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_03_menu', next);
        }
    },
    {
        path: "/catalogo/areas",
        name: "areas",
        component: areasIndex,
        beforeEnter: (to, from, next) => {
            guard('BO_07_menu_area', next);
        }
    },
    {
        path: "/catalogo/regimenFiscal",
        name: "regimenFiscal",
        component: RegimenFiscal,
        beforeEnter: (to, from, next) => {
            guard('Fac_4.0', next);
        }
    },






    {
        path: "/administracion/sesiones",
        name: "AdministracionSesion",
        component: AdministracionSesion,
        beforeEnter: (to, from, next) => {
            guard('AS_01_admin_sesiones', next);
        }
    },
    {
        path: "/corteCaja",
        name: "corteCaja",
        component: corteCaja,
        beforeEnter: (to, from, next) => {
            guard('PR_corte_caja', next);
        }
    },

    {
        path: "/reportes/requisiciones",
        name: "ReporteRequisiciones",
        component: ReporteRequisiciones,
        beforeEnter: (to, from, next) => {
            guard('RR_01_Reporte_requisición', next);
        }
    },
    {
        path: "/bandejaespecialista",
        name: "bandejaespecialista",
        component: BandejaEspecialista,
        beforeEnter: (to, from, next) => {
            guard('DX_06_bandeja_especial', next);
        }
    },
    {
        path: "/cuentas",
        name: "AdministracionCuentas",
        component: AdministracionCuentas,
        beforeEnter: (to, from, next) => {
            guard('CU_01_ctas_terminales', next);
        }
    },
    {
        path: "/compensaciones",
        name: "Compensaciones",
        component: Compensaciones,
        beforeEnter: (to, from, next) => {
            guard('C0_01_Com_menu', next);
        }
    },
    {
        path: "/bandejaoghallazgo",
        name: "BandejaDoctorHallazgo",
        component: BandejaDoctorHallazgo,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_bandeja_og', next);
        }
    },
    {
        path: "/bandejaHallazgo/rechazados",
        name: "bandejaHallazgoRechazados",
        component: BandejaHallazgoRechazados,
        beforeEnter: (to, from, next) => {
            guard('BJ_02_hallaz_rech', next);
        }
    },
    {
        path: "/bandejaCE/replica/rechazados",
        name: "BandejaCoordinadorEspecialidadReplicaRechazada",
        component: BandejaCoordinadorEspecialidadReplicaRechazada,
        beforeEnter: (to, from, next) => {
            guard('BJ_02_repli_rech', next);
        }
    },

    {
        path: "/reporte/ingresos",
        name: "reporteIngreso",
        component: ReporteIngresos,
        beforeEnter: (to, from, next) => {
            guard('RI_02_ingresos', next);
        }
    },
    {
        path: "/reporte/arpu",
        name: "ReporteArpu",
        component: ReporteArpu,
        beforeEnter: (to, from, next) => {
            guard('RP_Arpu', next);
        }
    },
    {
        path: "/reporte/txPxa",
        name: "ReporteTxPxa",
        component: ReporteTxPxa,
        beforeEnter: (to, from, next) => {
            guard('RP_tx_px_a', next);
        }
    },
    {
        path: "/reporte/consultaDiaria",
        name: "ConsultaDiaria",
        component: ReporteConsultaDiaria,
        beforeEnter: (to, from, next) => {
            guard('RP_tx_px_a', next);
        }
    },
    {
        path: "/reporte/atenciones",
        name: "ReporteAtenciones",
        component: ReporteAtenciones,
        beforeEnter: (to, from, next) => {
            guard('Atencion_01_px', next)
        }
    },
    {
        path: "/reporte/gestionVentas",
        name: "GestionVentas",
        component: ReporteGestionVentas,
        beforeEnter: (to, from, next) => {
            guard('Gestion_01_ventas', next);
        }
    },
    {
        path: "/reporte/detalle-ingresos",
        name: "reporteDetalleIngreso",
        component: ReporteIngresoDetalle,
        beforeEnter: (to, from, next) => {
            guard('RI_02_detalle_ingresos', next);
        }
    },
    {
        path: "/planes/asignar/editar/paciente",
        name: "asignarEditarPlanConvenioPaciente",
        component: AsignarEditarPlanConvenioPaciente,
        beforeEnter: (to, from, next) => {
            guard('PC_01_Px_PlanConv', next);
        }

    },
    {
        path: "/reporte",
        name: "reporte",
        component: Reporte,
        beforeEnter: (to, from, next) => {
            guard('PR_01_menu', next);
        }
    },
    {
        path: "/reporte/citas",
        name: "reporteCitas",
        component: reporteCitas,
        beforeEnter: (to, from, next) => {
            guard('RP_02_citas_clinica', next);
        }
    },
    {
        path: "/reporteEscenarioPTISV2",
        name: "reporteEscenarioPTISV2",
        component: reporteEscenarioPTISV2,
        beforeEnter: (to, from, next) => {
            guard('Rep_UP_M2', next);
        }
    },
    {
        path: "/reporte/ingresos/doctor",
        name: "reporteIngresosDoctor",
        component: reporteIngresosDoctor,
        beforeEnter: (to, from, next) => {
            guard('RP_05_Ingresos_Dr', next);
        }
    },

    {
        path: "/reporte/precios/tratamiento",
        name: "reportePreciosTratamiento",
        component: reportesPreciosTratamientos,
        beforeEnter: (to, from, next) => {
            guard('RP_04_prec_tratami', next);
        }
    },
    {
        path: "/reportesPTIS",
        name: "reportesEscenariosPTIS",
        component: reportesEscenariosPTIS,
        beforeEnter: (to, from, next) => {
            guard('Rep_seguimiento_M2', next);
        }
    },
    {
        path: "/reporte/salubridad",
        name: "reporteSalubridad",
        component: reporteSalubridad,
        beforeEnter: (to, from, next) => {
            guard('RP_03_rep_salubridad', next);
        }
    },
    {
        path: "/reporte/tratamientos/realizados",
        name: "reporteTratamientosRealizados",
        component: reporteTratamientosRealizados,
        beforeEnter: (to, from, next) => {
            guard('RP_01_tx_realizados', next);
        }
    },
    {
        path: "/modulos",
        name: "modulos",
        component: Modulos,
        beforeEnter: (to, from, next) => {
            guard('MP_01_Admin_modulos', next);
        }
    },

    {
        path: "/padecimientos",
        name: "padecimientos",
        component: PadecimientosVista,
        beforeEnter: (to, from, next) => {
            guard('Px_01_catalog_px', next);
        }
    },
    {
        path: "/PagoMSI",
        name: "PagoMSI",
        component: PagoMSI,
        beforeEnter: (to, from, next) => {
            guard('M2_msi', next);
        }
    },
    {
        path: "/planes/paciente/masivo",
        name: "planMasivoPaciente",
        component: altaPlanesMasivo,
        beforeEnter: (to, from, next) => {
            guard('PM_01_plan_PxMasivo', next);
        }
    },
    {
        path: "/catalogo/configuracionPuesto",
        name: "configuracionPuesto",
        component: configuracionPuesto,
        beforeEnter: (to, from, next) => {
            guard('AP_01_admin_puest', next);
        }
    },
    {
        path: "/bandeja/clinica",
        name: "BandejaClinicaHallazgo",
        component: BandejaClinicaHallazgo,
        beforeEnter: (to, from, next) => {
            guard('BJ_03_bandeja_cc', next);
        }
    },
    {
        path: "/perfil-laboral",
        name: "perfilLaboral",
        component: especialidades,
        beforeEnter: (to, from, next) => {
            guard('PL_01_admin_PerfilLab', next);
        }
    },

    {
        path: "/convenio/membresias",
        name: "ConvenioMembresias",
        component: ConvenioMembresias,
        beforeEnter: (to, from, next) => {
            guard('CM_Conven_membr', next);
        }
    },
    {
        path: "/reporte/corte-de-caja",
        name: "reporteCaja",
        component: reporteCorte,
        beforeEnter: (to, from, next) => {
            guard('RC_01_reporte_CC', next);
        }
    },
    {
        path: "/empresas/cuentas/admin",
        name: "AdminCuentas",
        component: AdminCuentas,
        beforeEnter: (to, from, next) => {
            guard('CP_01_cuenta_plan', next);
        }
    },
    {
        path: "/reporte/ingresos/proyeccion",
        name: "ReporteIngresoConProyeccionYObjetivos",
        component: ReporteIngresoConProyeccionYObjetivos,
        beforeEnter: (to, from, next) => {
            guard('RI_01_rp_ingreso_proyec', next);
        }
    },
    {
        path: "/facturas/globales",
        name: "FacturasGlobales",
        component: AdministracionFacturas,
        beforeEnter: (to, from, next) => {
            guard('FG_01_factura_global', next);
        }
    },
    {
        path: "/planes/baja-por-archivo",
        name: "BajaPorArchivo",
        component: BajaPorArchivo,
        beforeEnter: (to, from, next) => {
            guard('Bj_archivo_plan', next);
        }
    },
    {
        path: "/planes/descuento-tratamiento",
        name: "DescuentoTratamiento",
        component: DescuentoTratamiento,
        beforeEnter: (to, from, next) => {
            guard('DT_desc_tx_plan', next);
        }
    },
    {
        path: "/planes/pacientes/bbva",
        name: "AltaPacientesBbva",
        component: AltaPacientesBbva,
        beforeEnter: (to, from, next) => {
            guard('CA_01_carga_convenio', next);
        }
    },
    {
        path: "/planes/canje",
        name: "canje",
        component: canje,
        beforeEnter: (to, from, next) => {
            guard('CJ_canje_px', next);
        }
    },
    {
        path: "/bandejaEmbajadorHallazgoRechazadosPendientes",
        name: "bandejaEmbajadorHallazgoRechazadosPendientes",
        component: BandejaEmbajadorHallazgoRechazadosPendientes,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_Seguim_m2', next);
        }
    },
    {
        path: "/informacion-cortes-clinicas",
        name: "infCortes",
        component: FacturasCorteCaja,
        beforeEnter: (to, from, next) => {
            guard('CC_Admin_facc_global', next);
        }
    },
    {
        path: "/facturas/notas-credito",
        name: "notasCredito",
        component: NotaCredito,
        beforeEnter: (to, from, next) => {
            guard('ND_01_fact_nota', next);
        }
    },
    {
        path: "/comisiones/general",
        name: "comisionesGeneral",
        component: ComisionesDos,
        beforeEnter: (to, from, next) => {
            guard('C0_01_RP_comisiones', next);
        }
    },
    {
        path: "/garantias",
        name: "garantias",
        component: Garantias,
        beforeEnter: (to, from, next) => {
            guard('GT_garantias', next);
        }
    },
    {
        path: "/bandejacobro",
        name: "BandejaCobro",
        component: BandejaCobro,
        beforeEnter: (to, from, next) => {
            guard('CC_01_caja_cobro', next);
        },
    },
    {
        path: '/movimiento/lista',
        name: "Movimientos",
        component: Movimientos,
        beforeEnter: (to, from, next) => {
            guard('MV_mv_movimientos_lista', next);
        },
    },
    {
        path: '/movimiento/crear',
        name: "CrearMovimiento",
        component: CrearMovimiento,
        beforeEnter: (to, from, next) => {
            guard('MV_mv_movimientos_crear', next);
        },
    },
    {
        path: '/tratamientos/precios',
        name: "PreciosTratamientos",
        component: PreciosTratamientos,
        beforeEnter: (to, from, next) => {
            guard('Cons_01_Precio', next);
        },
    },

    {
        path: "/etl/principal",
        name: "etl",
        component: ETLPrincipal,
        beforeEnter: (to, from, next) => {
            guard('BO_etl_consulta', next);
        },
    },
    {
        path: '/caja-de-cobro/sesion/:idSesion',
        name: "cajaSesion",
        component: cajaSesion,
        beforeEnter: (to, from, next) => {
            guard('Caja_cobro', next);
        },
    },
    {
        path: '/caja-de-cobro/sesion/:idSesion/rpti',
        name: "cajaSesionRenegociar",
        component: cajaSesion,

    },
    {
        path: "/etl/caracteres",
        name: "etlCaracteres",
        component: ETLCaracteres,
        beforeEnter: (to, from, next) => {
            guard('BO_etl_caracteres', next);
        },
    },
    {
        path: "/colaboradores/bandejasolicitudes/bajas",
        name: "solicitudbaja",
        component: SolicitudBaja,
        beforeEnter: (to, from, next) => {
            guard('BJ_baja_coolaborador', next);
        },
    },
    {
        path: "/catalogo/promociones",
        name: "promociones",
        component: promociones,
        beforeEnter: (to, from, next) => {
            guard('admin_01_promociones', next);
        },
    },
    {
        path: "/catalogo/promociones/:idPromocion",
        name: "formularioPromocion",
        component: formularioPromociones,
        beforeEnter: (to, from, next) => {
            guard('admin_01_promociones', next);
        },
    },

    {
        path: "/catalogo/motivoRechazoPx",
        name: "motivoRechazoPti",
        component: motivoRechazoPti,
        beforeEnter: (to, from, next) => {
            guard('CT_01_PTI_Rechazo_Px', next);
        }
    },
    {
        path: "/catalogo/MotivoRechazoEE",
        name: "MotivoRechazoEE",
        component: MotivoRechazoEE,
        beforeEnter: (to, from, next) => {
            guard('CT_01_PTI_Rechazo_EE', next);
        }
    },
    {
        path: "/catalogo/cargaHdxEce",
        name: "cargaHdxEce",
        component: cargaHdxEce,
        beforeEnter: (to, from, next) => {
            guard('ECE_01_conf_Hdx', next);
        }
    },
    {
        path: "/dealers/agentespromotores/activacionusuarios",
        name: "AgentesPromotores",
        component: AgentesPromotores,
        beforeEnter: (to, from, next) => {
            guard('Ag_01_Promotores', next);
        },
    },
    {
        path: "/reporte/reembolsos",
        name: "reporteReembolsos",
        component: reporteReembolsos,
        beforeEnter: (to, from, next) => {
            guard('RP_01_Reembolsos', next);
        }
    },
    {
        path: "/catalogo/configuracionHdxCompletas",
        name: "configuracionHdxCompletas",
        component: configuracionHdxCompletas,
        beforeEnter: (to, from, next) => {
            guard('Conf_01_Param_hdx', next);
        }
    },
    {
        path: "/reporte/asignacionpolizas",
        name: "ReporteAsignacionPolizas",
        component: reporteAsignacionPolizas,
        beforeEnter: (to, from, next) => {
            guard('RP_01_reporte_BBVA', next);

        }
    },

    {
        path: "/quejas/index",
        name: "generarqueja",
        component: GarantiasIndex,
        beforeEnter: (to, from, next) => {
            guard('Queja_01_crear', next);

        }
    },
    {
        path: "/quejas/clinicas",
        name: "quejasClinicas",
        component: QuejasClinica,
        beforeEnter: (to, from, next) => {
            guard('Queja_01_crear_cli', next);

        }
    },

    {
        path: "/garantias/intentos/:id/:idEtapa",
        name: "garantiasIntentos",
        component: IntentosSLA
    },
    {
        path: "/garantias/intentos/solucion/:id/:idEtapa",
        name: "garantiasIntentosSolucion",
        component: IntentosSLA2
    },
    {
        path: "/garantias/dictamen-operativo/:id/:idEtapa",
        name: "garantiasDictamenO",
        component: dicatamenOperativo
    },
    {
        path: "/garantias/dictamen-operativo/cz/:id/:idEtapa",
        name: "garantiasDictamenOcz",
        component: dicatamenOperativoCz
    },
    {
        path: "/garantias/dictamen-operativo/vo/:id/:idEtapa",
        name: "garantiasDictamenOvo",
        component: dicatamenOperativoVo
    },
    {
        path: "/garantias/dictamen-dental/:id/:idEtapa",
        name: "garantiasDictamenCCEE",
        component: DentalDictamen
    },

    {
        path: "/garantias/revision/dictamenes/:id/:idEtapa",
        name: "garantiasDictamenrevision",
        component: RevisionDictamenes
    },
    {
        path: "/garantias/grave-garantia/:id/:idEtapa",
        name: "garantiaGraveGarantia",
        component: FormularioComplementarioQueja
    },
    {
        path: "/garantias/aceptacion/:id/:idEtapa",
        name: "garantiaAceptacion",
        component: AceptacionSolicitud
    },

    {
        path: "/garantias/revision/:id/:idEtapa",
        name: "garantiasRevision",
        component: RevisionSolicitudQueja
    },
    {
        path: "/garantias/cerrar-caso/:id/:idEtapa",
        name: "cerrar",
        component: CerrarCaso
    },

    {
        path: "/bandeja/solicitudes",
        name: "bandejasolicitudes",
        component: BandejaQuejas,
        beforeEnter: (to, from, next) => {
            guard('Bj_01_motor_solicitudes', next);
        }
    },
    {
        path: "/bandeja/seguimiento",
        name: "BandejaEmbajadorSeguimiento",
        component: BandejaEmbajadorSeguimiento,
        beforeEnter: (to, from, next) => {
            guard('BJ_01_Seg_EE_PTI', next);

        }
    },

    {
        path: "/catalogo/tipoSolicitud",
        name: "tipoSolicitud",
        component: tipoSolicitud,
        beforeEnter: (to, from, next) => {
            guard('Sol_01_tipoSolicitudPTI', next);

        }

    },

    {
        path: "/facturacion/dentalia",
        name: "facturaLinea",
        component: FacturaLinea,
    },
    {
        path: "/reporte/renovacionAutomaticaPortalComercial",
        name: "adminPortalComercial",
        component: adminPortalComercial,
        beforeEnter: (to, from, next) => {
            guard('Rep_01_vtas_portal_comer', next);

        }
    },
    {
        path: "/administracion/renovacionAutomaticaPortalComercial",
        name: "adminRenovacionPortalComercial",
        component: adminRenovacionPortalComercial,
        beforeEnter: (to, from, next) => {
            guard('Admin_01_Portal_Comercial', next);

        }
    },
    {
        path: "/sla/seguimiento/pti",
        name: "slaSeguimientoPti",
        component: SLASeguimientoPTI,
        beforeEnter: (to, from, next) => {
            guard('SLA_01_Sol_PTI_semaforo', next);

        }
    },
    {
        path: "/facturacionLineaPortal/:token",
        name: "facturacionLineaPortal",
        component: facturacionLineaPortal,
    },
    {
        path: "/facturacionLineaPortalV2/:token(.*)*",
        name: "FacturacionLineaPortalV2",
        component: FacturacionLineaPortalV2,
    },
    {
        path: "/configuracion/financiamiento",
        name: "configuracionFinanciamiento",
        component: TabsFinanciamiento,
        beforeEnter: (to, from, next) => {
            guard('Conf_01_financiamiento', next);

        }
    },
    {
        path: "/bandeja/interconsulta",
        name: "bandejaInterconsulta",
        component: BandejaInterConsultaFull,
        beforeEnter: (to, from, next) => {
            guard('IC_01_intercosulta', next);

        }
    },


    {
        path: "/configuracion/avpt",
        name: "ConfiguracionAvpt",
        component: ConfiguracionAvpt,
        beforeEnter: (to, from, next) => {
            guard('Conf_01_avpt', next);

        }
    },
    {
        path: "/reporte/reporteUsabilidad",
        name: "reporteUsabilidad",
        component: reporteUsabilidad,
        beforeEnter: (to, from, next) => {
            guard('Rp_01_Usabilidad', next);

        }
    },
    {
        path: "/adminPortalSocios/documentacionLegal",
        name: "documentacionLegal",
        component: documentacionLegal,
        beforeEnter: (to, from, next) => {
            guard('PAS_01_portal_autoservicio', next);

        }
    },
    {
        path: "/catalogo/tipoDocumentoLegal",
        name: "tipoDocumentoLegal",
        component: tipoDocumentoLegal,
        beforeEnter: (to, from, next) => {
            guard('PAS_02_Doc_legales', next);

        }
    },



    {
        path: "/configuracionBandejaAvpt",
        name: "configuracionBandeja",
        component: ConfiguracionEstatus,
        beforeEnter: (to, from, next) => {
            guard('Conf_01_avpt_BJ', next);
        }
    },

    {
        path: "/bandejaAvpt",
        name: "bandejaSeguimiento",
        component: BandejaSeguimiento,
        beforeEnter: (to, from, next) => {
            guard('Consulta_01_avpt_BJ', next);
        }
    },
    {
        path: "/bandejaAvptAnfitrion",
        name: "bandejaSeguimientoAnfitrion",
        component: BandejaSeguimientoAnfitrion,
        beforeEnter: (to, from, next) => {
            guard('Acciones_01_avpt_BJ', next);
        }
    },

    {
        path: "/medicionIndicadorAvpt",
        name: "MedicionIndicadorAvpt",
        component: MedicionIndicadorAvpt,
        beforeEnter: (to, from, next) => {
            guard('Indicadores_AVPT', next);
        }
    },


    {
        path: "/qr/:token(.*)",
        name: "QRECE",
        component: QREce,
    },
    {
        path: "/terminosCondiciones/:idAvisoSistema",
        name: "terminosCondiciones",
        component: terminosCondiciones,
    },

    {
        path: "/comisionesEspecialista",
        name: "comisionesEspecialista",
        component: ComisionesEspecialista,
        beforeEnter: (to, from, next) => {
            guard('Crud_Bloque', next);
        }
    },
    {
        path: "/Cdx/centroValidacionDx/:id/:idSolicitudEtapa/:idSolicitud/:idEtapa",
        name: "validacionDes",
        component: ValidacionPTI,
        beforeEnter: (to, from, next) =>{
            guard('Bj_Sol_Descentralizada_cdx', next);
        }
    },
    {
        path: "/bandejaDescentralizacionRechazados",
        name: "BandejaDescentralizacionRechazados",
        component: BandejaDescentralizacionRechazados,
        beforeEnter: (to, from, next) =>{
            guard('Bj_rechazo_descentralizado', next);
        }
    },


    {
        path: "/bandejaListaEspera",
        name: "listaEspera",
        component: ListaEspera,
        beforeEnter: (to, from, next) => {
            guard('BJ_lista_de_espera', next);
        }
      },
      {
        path: "/configuracionEstatusListaEspera",
        name: "EstatusListadeEspera",
        component: EstatusListadeEspera,
        beforeEnter: (to, from, next) => {
            guard('Conf_Lista_de_espera', next);
        }
      },
      {
        path: "/bandaMultiplicador",
        name: "BandaMultiplicador",
        component: BandaMultiplicador,
        beforeEnter: (to, from, next) => {
          guard('Crud_multiplicador', next);
        }
      },
      {
        path: "/cfdi",
        name: "CFDI",
        component: CFDI,
        beforeEnter: (to, from, next) => {
            guard('Conf_CFDI', next);
        }
    },


    {
        path: "/administracionRespuesta",
        name: "AdministracionRespuesta",
        component: AdministracionRespuesta,
        beforeEnter: (to, from, next) =>{
            guard('Conf_CFDI', next);
        }
    },

    {
        path: "/scheduleNuevo",
        name: "ScheduleNuevo",
        component: ScheduleNuevo,
        beforeEnter: (to, from, next) =>{
            guard('Agenda_nsd', next);
        }
    },
    {
        path: "/respuestaRecordatorioCorreoPago/:ticketToken(.*)*",
        name: "respuestaRecordatorioCorreoPago",
        component: respuestaRecordatorioCorreoPago,
    },

    {
        path: "/configuracionFormularioHc",
        name: "configuracionFormularioHc",
        component: ConfiguracionFormularioHc,
        beforeEnter: (to, from, next) =>{
            guard('HC_administracion', next);
        }
    },
    {
        path: "/preguntasHc/:idClasificacion/:clasif/:idDenticion",
        name: "preguntasHc",
        component: PreguntasHc,
        beforeEnter: (to, from, next) =>{
            guard('HC_administracion', next);
        }
    },

    {
        path: "/bandeja/borradores",
        name: "borradores",
        component: BandejaBorradores,
        beforeEnter: (to, from, next) =>{
            guard('BJ_Borrador_hdx', next);
        }
    },

    {
        path: "/catalogo/extension",
        name: "Extension",
        component: extension,
        beforeEnter: (to, from, next) =>{
            guard('ECE_config_Extencion', next);
        }

    },
    {
        path: "/catalogo/estatusCategoria",
        name: "EstatusCategoria",
        component: EstatusCategoria,
        beforeEnter: (to, from, next) =>{
            guard('Estatus_categoria_Tx', next);
        }

    },
    {
        path: "/catalogo/flujoExpedienteDigital",
        name: "FlujoExpedienteDigital",
        component: flujoExpedienteDigital,
        beforeEnter: (to, from, next) =>{
            guard('ECE_config_flujo', next);
        }

    },
    {
        path: "/catalogo/cupones",
        name: "Cupones",
        component: cupones,
        beforeEnter: (to, from, next) =>{
            guard('Admin_cupon', next);
        }
    },
    {
        path: "/catalogo/vales",
        name: "Vales",
        component: vales,
        beforeEnter: (to, from, next) =>{
            guard('Asignar_vales', next);
        }

    },
    {
        path: "/catalogo/categoriaNuevo",
        name: "CategoriaNuevo",
        component: categoriaNuevo,
        beforeEnter: (to, from, next) =>{
            guard('Conf_cat_ctg', next);
        }
    },



    {
        path: "/planeacionPti",
        name: "PlanningPti",
        component: PlanningPti,
        beforeEnter: (to, from, next) =>{
            guard('Planea_diaria_ee', next);
        }

    },
    {
        path: "/Historial/PlanesTratamientos/Inactivos",
        name: "TratamientosPlanesInactivos",
        component: TratamientosPlanesInactivos,
        beforeEnter: (to, from, next) =>{
            guard(   'Historial_txinactivo', next);
        }
    },
    {
        path: "/catalogo/tratamientos",
        name: "CatalogoTratamientos",
        component: CatalogoTratamientos,
        beforeEnter: (to, from, next) =>{
            guard('Tx_sku_Producto', next);
        }
    },
    {
        path: "/catalogo/caracteristicasCategoria",
        name: "caracteristicasCategoria",
        component: caracteristicasCategoria,
        beforeEnter: (to, from, next) =>{
            guard('Config_categorias', next);
        }
    },
    {
        path: "/colaborador",
        name: "CrearEditarColaborador",
        component: CrearEditarColaborador,
        beforeEnter: (to, from, next) =>{
            guard('BO_15_guardar', next);
        }
    },
    {
        path: "/catalogo/valor",
        name: "Valor",
        component: Valor,
        beforeEnter: (to, from, next) =>{
            guard(   'Tx_valor_vist', next);
        }
    },
    {
        path: "/catalogo/extension-tx",
        name: "extension-tx",
        component: Extension,
        beforeEnter: (to, from, next) =>{
            guard(   'Tx_extension_vist', next);
        }
    },
    {
        path: "/nuevoEsquema/comisiones",
        name: "NuevoEsquemaComisiones",
        component: NuevoEsquemaComisiones,
        beforeEnter: (to, from, next) =>{
            guard('NuevaComision', next);
        }
    },


    /*
    * ************Todo nuevo- Version 5 *********************
    */
    {
        path: "/resumen/inversion/:idPti/:idSolicitudEtapa/:idSolicitud/:idEtapa",
        name: "resumenInversion",
        component: resumenInversion,
    },
    {
        path: "/metodos/inversion/:idPti/:idSolicitudEtapa/:idSolicitud/:idEtapa/:opcion",
        name: "metodosPago",
        component: MetodosPagov5,
    },
    {
        path: "/distribucion/inversion/:idPti/:idSolicitudEtapa/:idSolicitud/:idEtapa/:opcion",
        name: "distribucionPagoPTIv5",
        component: DistribucionPagoPTIv5,
    },
    {
        path: "/impresion/pti/:idPti/:idSolicitudEtapa/:idSolicitud/:idEtapa/:opcion",
        name: "impresionPtiv5",
        component: ImpresionPtiv5,
    },

    {
        path: "/hojaDiagnostico",
        name: "HojaDiagnostico",
        component: HojaDiagnostico,
    },
    {
        path: "/catalogo/categoriaArgumentario",
        name: "CategoriaArgumentario",
        component: CategoriaArgumentario,
        beforeEnter: (to, from, next) =>{
            guard('Cat_argumento', next);
        }
    },
    {
        path: "/argumentario/:id/:tratamiento",
        name: "argumentario",
        component: ArgumentarioV2,
    },
    {
        path: "/alineadores",
        name: "BandejaInvisaling",
        component: BandejaInvisaling,
        beforeEnter: (to, from, next) =>{
            guard('BJ_invisalign', next);
        }
    },
    {
        path: "/bandejaEmbajadorHallazgoV5/:tab",
        name: "bandejaEmbajadorHallazgoTabsV5",
        component: BandejaEmbajadorHallazgoV5,
    },
    {
        path: "/bandejaEmbajadorHallazgoV5",
        name: "bandejaEmbajadorHallazgoV5",
        component: BandejaEmbajadorHallazgoV5,
    },
    {
        path: "/edicion/:idPaciente/:idPti/:idEtapa",
        name: "SolicitudEdicion",
        component: SolicitudEdicion,
        beforeEnter: (to, from, next) =>{
            guard('Bj_n_val_esp', next);
        }
    },
    {
        path: "/kits",
        name: "KitConfiguracion",
        component: KitConfiguracion,
        beforeEnter: (to, from, next) =>{
            guard('Confg_kits', next);
        }
    },
    {
        path: "/pacienteOrtopantomografo",
        name: "pacienteOrtopantomografo",
        component: PacienteOrtopantomografo,
        beforeEnter: (to, from, next) =>{
            guard('Ortopantomografo', next);
        }
    },

    /*-----------INICIO laboratorio*/

    {
        path: "/laboratorio/preparacion/:idSolicitud/:idEtapa",
        name: "preparacionLab",
        component: Preparacion
    },
    {
        path: "/laboratorio/recoleccion/:idSolicitud/:idEtapa",
        name: "recoleccionLab",
        component: Recoleccion
    },
    {
        path: "/laboratorio/arribo/:idSolicitud/:idEtapa",
        name: "arriboLab",
        component: Arribo
    },
    {
        path: "/laboratorio/ingreso/:idSolicitud/:idEtapa",
        name: "IngresoLab",
        component: IngresoCalidad
    },
    {
        path: "/laboratorio/produccion/:idSolicitud/:idEtapa",
        name: "produccionLab",
        component: Produccion
    },
    {
        path: "/laboratorio/ingreso/clinica/:idSolicitud/:idEtapa",
        name: "IngresoCli",
        component: IngresoClinica
    },
    {
        path: "/catalogo/proveedoresERP",
        name: "proveedoresERP",
        component: ProveedoresERP,
        beforeEnter: (to, from, next) => {
            guard('Cat_Proveedores', next);
        }
    },
	{
        path: "/catalogo/categoriaPromocion",
        name: "CategoriaPromociones",
        component: CategoriaPromociones,
        beforeEnter: (to, from, next) =>{
            guard('admin_categoria_promocion', next);
        }
    },
    {
        path: "/catalogo/estadoPromocion",
        name: "EstatusPromocion",
        component: estatusPromocion,
        beforeEnter: (to, from, next) =>{
            guard('Cat_est_promocion', next);
        }
    },

    {
        path: "/promocion/:id",
        name: "PromocionesV2",
        component: PromocionesV2
    },

    {
        path: "/lista/promociones/v2",
        name: "ListaPromociones",
        component: ListaPromociones,
        beforeEnter: (to, from, next) =>{
            guard('Promociones_01', next);
        }
    },

    {
        path: "/catalogo/plazoFijo",
        name: "PlazoFijo",
        component: PlazoFijo,
        beforeEnter: (to, from, next) =>{
            guard('Plazofijo_01', next);
        }
    },
    {
        path: "error",
        name: "FacturacionExpiroLink",
        component: FacturacionExpiroLink
    },
    {
        path: "/banner/pti",
        name: "Banner",
        component: GestionBannerPTI,
        beforeEnter: (to, from, next) =>{
            guard('Mkt_Banner', next);
        }
    },
    


    /*
    *
    * Laboratorios v2025
    *
    */
    {
        path: "/catalogo/laboratorios",
        name: "laboratorios",
        component: Laboratorios,
        beforeEnter: (to, from, next) => {
            guard('laboratorios_lab', next);
        }
    },
    {
        path: "/catalogo/colorimetros",
        name: "colorimetros",
        component: Colorimetros,
        beforeEnter: (to, from, next) => {
            guard('colorimetros_lab', next);
        }
    },
    {
        path: "/catalogo/escaner",
        name: "Escaner",
        component: CatalogoEscaner,
        beforeEnter: (to, from, next) => {
            guard('escaner_lab', next);
        }
    },
    {
        path: "/odt/:idPaciente/:nombrePaciente/:edad/:sexo/:idOdt/:tipoOdt/:origenOdt/:idSolicitud",
        name: "odenTrabajoPaciente",
        component: OrdenTrabajoPaciente,
    },
    {
        path: "/odt/:idPaciente/:idOdt/:idSolicitud/:idSolicitudEtapa/:idEtapa",
        name: "detalleOdtPaciente",
        component: DetalleOdtPaciente,
    },
     /*
      *
      * Laboratorios v2025
      *
      */
     
     {
        path: "/laboratorio/solicitudes",
        name: "bandejaGeneralOdts",
        component: BandejaGeneralOdts,
         beforeEnter: (to, from, next) => {
             guard('Lab_ODT_general', next);
         }
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
